"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isValidSortField = exports.getDefaultSortOrder = exports.getDefaultSortField = exports.filterKeyOrder = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = _interopRequireDefault(require("immutable"));

var _mapKeys = _interopRequireDefault(require("hs-lodash/mapKeys"));

var _memoize = _interopRequireDefault(require("hs-lodash/memoize"));

var _params = require("hub-http/helpers/params");

var DataSync = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/dataSyncs/Sync"));

var SuperCategory = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/SuperCategory"));

var Tier = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/Tier"));

var HubSpotFeature = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/HubSpotFeature"));

var _categoryFeatures = require("ecosystem-marketplace-core/constants/groupTags/categoryFeatures");

var PlanType = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/pricings/PlanType"));

var StorefrontCollection = _interopRequireWildcard(require("../constants/StorefrontCollection"));

var FilterKey = _interopRequireWildcard(require("../constants/search/FilterKey"));

var SortField = _interopRequireWildcard(require("../constants/search/SortField"));

var SortOrder = _interopRequireWildcard(require("../constants/search/SortOrder"));

var SupportSource = _interopRequireWildcard(require("../constants/search/SupportSource"));

var _groupTags = require("../utils/groupTags");

var _urls = require("../utils/urls");

var _Immutable$Map, _Immutable$Map2, _defaults;

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return (0, _typeof2.default)(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if ((0, _typeof2.default)(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if ((0, _typeof2.default)(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var EMPTY_SET = _immutable.default.Set();

var CATEGORY = FilterKey.CATEGORY,
    CERTIFIED = FilterKey.CERTIFIED,
    SYNC = FilterKey.SYNC,
    CATEGORY_FEATURES = FilterKey.CATEGORY_FEATURES,
    INTEGRATIONS = FilterKey.INTEGRATIONS,
    PLAN_COMPATIBLE = FilterKey.PLAN_COMPATIBLE,
    PRICING = FilterKey.PRICING,
    SUPER_CATEGORY = FilterKey.SUPER_CATEGORY,
    SUPPORT_SOURCE = FilterKey.SUPPORT_SOURCE,
    SUPPORT_LANGUAGES = FilterKey.SUPPORT_LANGUAGES,
    TIERS = FilterKey.TIERS,
    HUBSPOT_FEATURES = FilterKey.HUBSPOT_FEATURES,
    SEARCH = FilterKey.SEARCH,
    COLLECTION = FilterKey.COLLECTION,
    SORT_FIELD = FilterKey.SORT_FIELD,
    SORT_ORDER = FilterKey.SORT_ORDER,
    MIN_OVERALL_RATING = FilterKey.MIN_OVERALL_RATING;

var FILTER_KEY_VALUES = _immutable.default.List(Object.values(FilterKey));

var CATEGORY_FEATURES_SET = Object.values(_categoryFeatures.BY_CATEGORY).reduce(function (final, current) {
  return final.union(Object.values(current));
}, EMPTY_SET);

var TIERS_SET = _immutable.default.Set(Object.values(Tier));

var HUBSPOT_FEATURES_SET = _immutable.default.Set(Object.values(HubSpotFeature));

var DATA_SYNCS_SET = _immutable.default.Set(Object.values(DataSync));

var SUPPORT_SOURCE_SET = _immutable.default.Set(Object.values(SupportSource));

var PLAN_TYPE_SET = _immutable.default.Set(Object.values(PlanType));

var SORT_ORDER_SET = _immutable.default.Set(Object.values(SortOrder));

var SORT_FIELD_SET = _immutable.default.Set(Object.values(SortField));

var getDefaultSortField = function getDefaultSortField(collection) {
  switch (collection) {
    case StorefrontCollection.NEW:
    case StorefrontCollection.PIESYNC:
      return SortField.FIRST_PUBLISHED;

    default:
      return SortField.HUB_INSTALLS;
  }
};

exports.getDefaultSortField = getDefaultSortField;

var getDefaultSortOrder = function getDefaultSortOrder(collection) {
  // TODO handle other collections
  switch (collection) {
    default:
      return SortOrder.DESC;
  }
};

exports.getDefaultSortOrder = getDefaultSortOrder;
var isValidSortField = (0, _memoize.default)(function (collection, sortField) {
  switch (collection) {
    case StorefrontCollection.FREE:
      return [SortField.HUB_INSTALLS, SortField.FIRST_PUBLISHED, SortField.NAME].includes(sortField);

    case StorefrontCollection.PIESYNC:
      return [SortField.FIRST_PUBLISHED, SortField.NAME].includes(sortField);

    default:
      return true;
  }
}, function (collection, sortField) {
  return collection + "-" + sortField;
});
exports.isValidSortField = isValidSortField;

var filterKeyOrder = _immutable.default.OrderedSet([CATEGORY_FEATURES, PRICING, PLAN_COMPATIBLE, TIERS, HUBSPOT_FEATURES, SYNC, CERTIFIED, INTEGRATIONS, SUPPORT_SOURCE, SUPPORT_LANGUAGES, SEARCH, SORT_FIELD, SORT_ORDER, MIN_OVERALL_RATING]);

exports.filterKeyOrder = filterKeyOrder;

var filterValuesSetMap = _immutable.default.Map((_Immutable$Map = {}, (0, _defineProperty2.default)(_Immutable$Map, CATEGORY_FEATURES, CATEGORY_FEATURES_SET), (0, _defineProperty2.default)(_Immutable$Map, TIERS, TIERS_SET), (0, _defineProperty2.default)(_Immutable$Map, HUBSPOT_FEATURES, HUBSPOT_FEATURES_SET), (0, _defineProperty2.default)(_Immutable$Map, SYNC, DATA_SYNCS_SET), (0, _defineProperty2.default)(_Immutable$Map, SUPPORT_SOURCE, SUPPORT_SOURCE_SET), (0, _defineProperty2.default)(_Immutable$Map, PRICING, PLAN_TYPE_SET), (0, _defineProperty2.default)(_Immutable$Map, SORT_FIELD, SORT_FIELD_SET), (0, _defineProperty2.default)(_Immutable$Map, SORT_ORDER, SORT_ORDER_SET), _Immutable$Map));

var filterKeyEventPropertyMap = _immutable.default.Map((_Immutable$Map2 = {}, (0, _defineProperty2.default)(_Immutable$Map2, COLLECTION, 'category'), (0, _defineProperty2.default)(_Immutable$Map2, SUPER_CATEGORY, 'category'), (0, _defineProperty2.default)(_Immutable$Map2, CATEGORY, 'subcategory'), (0, _defineProperty2.default)(_Immutable$Map2, CATEGORY_FEATURES, 'feature'), (0, _defineProperty2.default)(_Immutable$Map2, MIN_OVERALL_RATING, 'minOverallRating'), (0, _defineProperty2.default)(_Immutable$Map2, PRICING, 'paymentType'), (0, _defineProperty2.default)(_Immutable$Map2, PLAN_COMPATIBLE, 'isCompatible'), (0, _defineProperty2.default)(_Immutable$Map2, TIERS, 'tier'), (0, _defineProperty2.default)(_Immutable$Map2, HUBSPOT_FEATURES, 'tool'), (0, _defineProperty2.default)(_Immutable$Map2, SYNC, 'integrationsSyncAccess'), (0, _defineProperty2.default)(_Immutable$Map2, CERTIFIED, 'listingStatus'), (0, _defineProperty2.default)(_Immutable$Map2, INTEGRATIONS, 'integration'), (0, _defineProperty2.default)(_Immutable$Map2, SUPPORT_SOURCE, 'provider'), (0, _defineProperty2.default)(_Immutable$Map2, SUPPORT_LANGUAGES, 'language'), (0, _defineProperty2.default)(_Immutable$Map2, SORT_FIELD, 'sortField'), (0, _defineProperty2.default)(_Immutable$Map2, SORT_ORDER, 'sortOrder'), (0, _defineProperty2.default)(_Immutable$Map2, SEARCH, 'search'), _Immutable$Map2));

var PARAM_PREFIX = 'eco_';
var defaults = (_defaults = {}, (0, _defineProperty2.default)(_defaults, CATEGORY, null), (0, _defineProperty2.default)(_defaults, SUPER_CATEGORY, null), (0, _defineProperty2.default)(_defaults, COLLECTION, null), (0, _defineProperty2.default)(_defaults, CATEGORY_FEATURES, EMPTY_SET), (0, _defineProperty2.default)(_defaults, MIN_OVERALL_RATING, null), (0, _defineProperty2.default)(_defaults, PRICING, null), (0, _defineProperty2.default)(_defaults, PLAN_COMPATIBLE, false), (0, _defineProperty2.default)(_defaults, TIERS, EMPTY_SET), (0, _defineProperty2.default)(_defaults, HUBSPOT_FEATURES, EMPTY_SET), (0, _defineProperty2.default)(_defaults, SYNC, null), (0, _defineProperty2.default)(_defaults, CERTIFIED, false), (0, _defineProperty2.default)(_defaults, INTEGRATIONS, EMPTY_SET), (0, _defineProperty2.default)(_defaults, SUPPORT_SOURCE, null), (0, _defineProperty2.default)(_defaults, SUPPORT_LANGUAGES, EMPTY_SET), (0, _defineProperty2.default)(_defaults, SEARCH, ''), (0, _defineProperty2.default)(_defaults, SORT_FIELD, null), (0, _defineProperty2.default)(_defaults, SORT_ORDER, null), _defaults);

var StorefrontFilters = /*#__PURE__*/function (_Immutable$Record) {
  (0, _inherits2.default)(StorefrontFilters, _Immutable$Record);

  function StorefrontFilters() {
    (0, _classCallCheck2.default)(this, StorefrontFilters);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(StorefrontFilters).apply(this, arguments));
  }

  (0, _createClass2.default)(StorefrontFilters, [{
    key: "fromQueryString",
    value: function fromQueryString(queryString) {
      var category = this[CATEGORY];
      var __category = defaults[CATEGORY],
          __superCategory = defaults[SUPER_CATEGORY],
          __collection = defaults[COLLECTION],
          queryDefaults = (0, _objectWithoutProperties2.default)(defaults, [CATEGORY, SUPER_CATEGORY, COLLECTION].map(_toPropertyKey));
      var parsedQuery = (0, _mapKeys.default)((0, _params.parse)(queryString), function (__value, key) {
        return key.replace(PARAM_PREFIX, '');
      });
      Object.keys(parsedQuery).forEach(function (key) {
        if (!FILTER_KEY_VALUES.includes(key)) {
          delete parsedQuery[key];
          return;
        }

        var defaultValue = defaults[key];

        var isSet = _immutable.default.Set.isSet(defaultValue);

        var value = parsedQuery[key];

        if (Array.isArray(value) && !isSet) {
          value = value[0];
        }

        if (isSet) {
          value = _immutable.default.Set(!Array.isArray(value) ? [value] : value);
        }

        if (key === CERTIFIED || key === PLAN_COMPATIBLE) {
          value = value === 'true';
        }

        if (key === CATEGORY_FEATURES && category) {
          value = (0, _groupTags.filterFeaturesByCategory)(value, category);
        } else if (filterValuesSetMap.has(key)) {
          var valuesSet = filterValuesSetMap.get(key);

          if (_immutable.default.Set.isSet(value)) {
            value = value.filter(function (val) {
              return valuesSet.includes(val);
            });
          } else if (!valuesSet.includes(value)) {
            delete parsedQuery[key];
            return;
          }
        }

        parsedQuery[key] = value;
      });
      return this.merge((0, _extends3.default)({}, queryDefaults, parsedQuery)).clean();
    }
  }, {
    key: "toQuery",
    value: function toQuery() {
      var query = this.clean().toJS();
      Object.keys(query).forEach(function (key) {
        var value = query[key];
        var isArray = Array.isArray(value);

        if (!value || isArray && !value.length) {
          delete query[key];
          return;
        }

        if (isArray) {
          query[key] = value.sort();
        }
      });
      return query;
    }
  }, {
    key: "toQueryString",
    value: function toQueryString() {
      var query = this.toQuery();
      delete query[SUPER_CATEGORY];
      delete query[CATEGORY];
      delete query[COLLECTION];
      return filterKeyOrder.reduce(function (final, key) {
        var value = query[key];

        if (value != null && value !== defaults[key]) {
          final.push((0, _params.stringify)((0, _defineProperty2.default)({}, "" + PARAM_PREFIX + key, value)));
        }

        return final;
      }, []).join('&');
    }
  }, {
    key: "toSearchQuery",
    value: function toSearchQuery() {
      var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var collection = this[COLLECTION],
          planType = this[PRICING],
          search = this[SEARCH],
          sortField = this[SORT_FIELD];
      var query = this.toQuery();

      if (sortField === SortField.PRICE) {
        var priceSortField;

        switch (planType) {
          case PlanType.MONTHLY:
            {
              priceSortField = SortField.MONTHLY_PRICE;
              break;
            }

          case PlanType.YEARLY:
            {
              priceSortField = SortField.YEARLY_PRICE;
              break;
            }

          case PlanType.ONE_TIME:
            {
              priceSortField = SortField.ONE_TIME_PRICE;
              break;
            }

          default:
            break;
        }

        query[SORT_FIELD] = priceSortField;
      }

      if (!sortField && !search) {
        query[SORT_FIELD] = getDefaultSortField(collection);
        query[SORT_ORDER] = getDefaultSortOrder(collection);
      }

      if (collection === StorefrontCollection.FREE) {
        query[PRICING] = PlanType.FREE;
        delete query[COLLECTION];
      } else if (collection === StorefrontCollection.FOR_MARKETING_TEAMS) {
        query[SUPER_CATEGORY] = SuperCategory.MARKETING;
        delete query[COLLECTION];
      } else if (collection === StorefrontCollection.FOR_SALES_TEAMS) {
        query[SUPER_CATEGORY] = SuperCategory.SALES;
        delete query[COLLECTION];
      } else if (collection === StorefrontCollection.FOR_CUSTOMER_SUCCESS_TEAMS) {
        query[SUPER_CATEGORY] = SuperCategory.CUSTOMER_SUCCESS;
        delete query[COLLECTION];
      } else if (collection === StorefrontCollection.HOMEMADE) {
        query[SUPPORT_SOURCE] = SupportSource.HUBSPOT;
        delete query[COLLECTION];
      }

      return (0, _extends3.default)({}, query, extra);
    }
  }, {
    key: "toEventProperties",
    value: function toEventProperties() {
      var query = this.toQuery();
      var certified = query[CERTIFIED],
          search = query[SEARCH];
      var properties = {};
      Object.keys(query).forEach(function (key) {
        var propertyKey = filterKeyEventPropertyMap.get(key);

        if (propertyKey) {
          properties[propertyKey] = query[key];
        }
      });

      if (certified) {
        properties.listingStatus = 'CERTIFIED';
      }

      if (search) {
        properties.searchLength = search.length;
      }

      return properties;
    }
  }, {
    key: "toLocation",
    value: function toLocation() {
      var collection = this[COLLECTION],
          superCategory = this[SUPER_CATEGORY],
          category = this[CATEGORY];
      var pathname;

      if (collection) {
        pathname = (0, _urls.getCollectionUrl)(collection);
      } else if (category) {
        pathname = (0, _urls.getCategoryFilterUrl)(category, superCategory);
      } else if (superCategory) {
        pathname = (0, _urls.getSuperCategoryFilterUrl)(superCategory);
      } else {
        pathname = (0, _urls.getAllCategoriesUrl)();
      }

      return {
        pathname: pathname,
        search: "?" + this.toQueryString()
      };
    }
  }, {
    key: "toAllCategories",
    value: function toAllCategories() {
      return this.withMutations(function (mutableFilters) {
        mutableFilters.delete(COLLECTION).delete(SUPER_CATEGORY).delete(CATEGORY);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var nuke = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (nuke) {
        return (0, _get2.default)((0, _getPrototypeOf2.default)(StorefrontFilters.prototype), "clear", this).call(this);
      }

      return this.withMutations(function (mutableFilters) {
        mutableFilters.delete(CATEGORY_FEATURES).delete(PRICING).delete(PLAN_COMPATIBLE).delete(TIERS).delete(HUBSPOT_FEATURES).delete(SYNC).delete(CERTIFIED).delete(INTEGRATIONS).delete(SUPPORT_SOURCE).delete(SUPPORT_LANGUAGES);
      });
    }
  }, {
    key: "clean",
    value: function clean() {
      var collection = this[COLLECTION],
          planType = this[PRICING],
          compatible = this[PLAN_COMPATIBLE],
          supportSource = this[SUPPORT_SOURCE],
          tiers = this[TIERS],
          search = this[SEARCH],
          sortField = this[SORT_FIELD];
      return this.withMutations(function (mutableFilters) {
        if (sortField) {
          if (sortField === SortField.RELEVANCE && !search) {
            mutableFilters.delete(SORT_FIELD).delete(SORT_ORDER);
          }

          if (sortField === SortField.RANDOM) {
            mutableFilters.delete(SORT_ORDER);
          }

          if (sortField === SortField.PRICE && planType === PlanType.FREE) {
            mutableFilters.delete(SORT_FIELD).delete(SORT_ORDER);
          }

          if (collection && !isValidSortField(collection, sortField)) {
            mutableFilters.delete(SORT_FIELD).delete(SORT_ORDER);
          }
        }

        if (compatible && tiers) {
          mutableFilters.delete(TIERS);
        }

        if (supportSource && collection === StorefrontCollection.HOMEMADE) {
          mutableFilters.delete(SUPPORT_SOURCE);
        }

        if (planType && (collection === StorefrontCollection.FREE || collection === StorefrontCollection.PIESYNC)) {
          mutableFilters.delete(PRICING);
        }
      });
    }
  }, {
    key: "getValidFilterTagKeys",
    value: function getValidFilterTagKeys() {
      var _this = this;

      return filterKeyOrder.filter(function (key) {
        var value = _this.get(key);

        if (key === SORT_FIELD || key === SORT_ORDER || key === SEARCH) {
          return false;
        }

        if (value == null || value === false) {
          return false;
        }

        if (_immutable.default.Set.isSet(value)) {
          return !value.isEmpty();
        }

        return true;
      });
    }
  }], [{
    key: "from",
    value: function from(filters) {
      var _extends2;

      var cleanedFilters = (0, _extends3.default)({}, filters, (_extends2 = {}, (0, _defineProperty2.default)(_extends2, CATEGORY_FEATURES, _immutable.default.Set(filters[CATEGORY_FEATURES])), (0, _defineProperty2.default)(_extends2, TIERS, _immutable.default.Set(filters[TIERS])), (0, _defineProperty2.default)(_extends2, HUBSPOT_FEATURES, _immutable.default.Set(filters[HUBSPOT_FEATURES])), (0, _defineProperty2.default)(_extends2, INTEGRATIONS, _immutable.default.Set(filters[INTEGRATIONS])), (0, _defineProperty2.default)(_extends2, SUPPORT_LANGUAGES, _immutable.default.Set(filters[SUPPORT_LANGUAGES])), _extends2));
      return new StorefrontFilters(cleanedFilters);
    }
  }]);
  return StorefrontFilters;
}(_immutable.default.Record(defaults));

var _default = StorefrontFilters;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./js/records/StorefrontFilters.js
// module id = 71
// module chunks = 209 210 211 212 213